import {
  PURCHASE_BUTTON_INFO_START,
  PURCHASE_BUTTON_INFO_SUCCESS,
  PURCHASE_BUTTON_INFO_ERROR,
  PURCHASE_BUTTON_INFO_CLEAR,
} from 'actions/payway';

const initialState = {
  inProgress: false,
  success: null,
  error: null,
  data: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PURCHASE_BUTTON_INFO_START: {
      return {
        inProgress: true,
        success: null,
        error: null,
        data: null,
      };
    }
    case PURCHASE_BUTTON_INFO_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case PURCHASE_BUTTON_INFO_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case PURCHASE_BUTTON_INFO_CLEAR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
